module.exports = __webpack_public_path__ + "img/ifast.1234c799.jpg";